import { render, staticRenderFns } from "./DistributionManagement.vue?vue&type=template&id=6f72ab3d&scoped=true&"
import script from "./DistributionManagement.vue?vue&type=script&lang=js&"
export * from "./DistributionManagement.vue?vue&type=script&lang=js&"
import style0 from "./DistributionManagement.vue?vue&type=style&index=0&id=6f72ab3d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f72ab3d",
  null
  
)

export default component.exports